import React, { useEffect, useState } from 'react';
import { OktaAuth } from '@okta/okta-auth-js';
import { SSOLoginCodeType } from '@/pages/home/pages/login/_config/constant';
import { history } from 'umi';
import { getBasePath } from '@/utils/utils';

export default function identityProviderFun({
  loginDomain,
  clientId,
  identityProvider,
  id,
}: SSOLoginCodeType) {
  const { redirect } = history.location?.query || {};
  const path = `/v2/login/thirdPartyLogin`;//需跟idp的控制台配置一致
  const redirectUri = window.location.origin + path;
  const state = JSON.stringify({
    clientId,
    companyId: id,
    redirect: redirect || '',
    identityProvider,
  });
  const dealState = encodeURIComponent(state);
  //确认domain不以/结尾
  const dealDomain = loginDomain?.endsWith('/')
    ? loginDomain.slice(0, -1)
    : loginDomain;

  switch (identityProvider?.toLowerCase()) {
    case 'google':
      window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?state=${dealState}&client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email%20profile&prompt=consent`;
      break;
    case 'okta':
      const oktaAuth = new OktaAuth({
        issuer: `https://${dealDomain}/oauth2/default`,
        clientId,
        redirectUri,
        state,
      });
      oktaAuth.signInWithRedirect();
      break;
    case 'auth0':
      window.location.href = `https://${dealDomain}/authorize?state=${dealState}&client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=openid%20profile%20email`;
      break;
    default:
      console.log('没有配置此授权方式');
  }
}
